import { Alert } from 'antd';

export const FUNDING_SUPPORT_EMAIL = 'success@erinapp.com';

function FundingUnavailable({ style }) {
	return (
		<Alert
			showIcon
			type="info"
			message="Credit card funding is unavailable."
			description={
				<>
					Contact{' '}
					<a href={`mailto:${FUNDING_SUPPORT_EMAIL}`}>{FUNDING_SUPPORT_EMAIL}</a>{' '}
					to fund your balance.
				</>
			}
			style={style}
		/>
	);
}

export default FundingUnavailable;
